const timeZones = {
  US: [
    "(ET) [-5:00] Eastern Time",
    "(CT) [-6:00] Central Time",
    "(MT) [-7:00] Mountain Time",
    "(PT) [-8:00] Pacific Time",
  ],
  UK: [
    "(GMT) [+0:00] Greenwich Mean Time",
    "(BST) [+1:00] British Summer Time",
  ],
  IN: ["(IST) [+5:30] Indian Standard Time"],
  AU: [
    "(AEST) [+10:00] Australian Eastern Standard Time",
    "(ACST) [+9:30] Australian Central Standard Time",
    "(AWST) [+8:00] Australian Western Standard Time",
  ],
  CA: [
    "(ET) [-5:00] Eastern Time",
    "(CT) [-6:00] Central Time",
    "(MT) [-7:00] Mountain Time",
    "(PT) [-8:00] Pacific Time",
  ],
  JP: ["(JST) [+9:00] Japan Standard Time"],
  BR: ["(BRT) [-3:00] Brasília Time"],
  FR: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  DE: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  RU: ["(MSK) [+3:00] Moscow Time", "(VLAT) [+10:00] Vladivostok Time"],
  CN: ["(CST) [+8:00] China Standard Time"],
  IT: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  ES: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  MX: ["(CT) [-6:00] Central Time", "(MT) [-7:00] Mountain Time"],
  NL: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  BE: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  CH: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  AT: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  ZA: ["(SAST) [+2:00] South Africa Standard Time"],
  AR: ["(ART) [-3:00] Argentine Time"],
  SG: ["(SGT) [+8:00] Singapore Standard Time"],
  NZ: ["(NZST) [+12:00] New Zealand Standard Time"],
  SE: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  NO: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  DK: [
    "(CET) [+1:00] Central European Time",
    "(CEST) [+2:00] Central European Summer Time",
  ],
  FI: [
    "(EET) [+2:00] Eastern European Time",
    "(EEST) [+3:00] Eastern European Summer Time",
  ],
};

export default timeZones;
